import React from "react";
import { CondimentSkeletonStyled } from "./CondimentSkeletonStyled";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const CondimentSkeleton: React.FC = () => (
  <CondimentSkeletonStyled>
    <div className="condiment-skeleton__list">
      {[...Array.from({ length: 24 })].map((_, index: number) => (
        <div className="condiment-skeleton__item" key={index}>
          <Skeleton height={180} />
        </div>
      ))}
    </div>
  </CondimentSkeletonStyled>
);

export default CondimentSkeleton;
